import { CONFIRMED_GET_TOKEN_MULTI_LIST } from "../actions/TokenMultiSytemType"
import { getPatientList } from "../../services/TokenmultiSystemService"

export function getTokenMultiListAction(showAlert = true, isMultiValue = "YES") {
  return async (dispatch, getState) => {
    try {
      const response = await getPatientList(isMultiValue)
      if (response && response.status === 200 && response.data?.status === "success") {
      
        dispatch({ type: CONFIRMED_GET_TOKEN_MULTI_LIST, payload: response.data.data })
      } else {
        if (showAlert) {
          console.error("Failed to get multi-system patients: Server error", response)
        }
      }
    } catch (error) {
      if (showAlert) {
        console.error("API Error:", error)
      }
    }
  }
}
